import { Component, ElementRef, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { ApiService } from '../../Services/api.service';
import { AuthService } from '../../Services/auth.service';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../Common/Components/spinner/spinner.component';
import { ConfirmPopupComponent } from '../../Common/Components/confirm-popup/confirm-popup.component';

@Component({
  selector: 'app-add-catalog',
  standalone: true,
  imports: [ReactiveFormsModule, NzButtonModule, CommonModule, NzFormModule, NzInputModule, SpinnerComponent, FormsModule, NzLayoutModule, NzRadioModule,
    NzCheckboxModule, NzSelectModule,ConfirmPopupComponent
  ],
  templateUrl: './add-catalog.component.html',
  styleUrl: './add-catalog.component.scss'
})
export class AddCatalogComponent {
  @Input() catalogData: any;
  @Output() catalogSaveEvt = new EventEmitter<string>();
  addEditCatalogForm: FormGroup = new FormGroup({});
  invalidForm: boolean = false;
  @ViewChild('catDesc') catDesc!: ElementRef;
  loading: boolean = false;
  showModal: boolean = false;

  constructor(private apiService: ApiService, private fb: FormBuilder, public authService: AuthService) { }

  ngOnInit(): void {
    this.initAddForm();
    this.addEditCatalogForm.get('checkoutMsg')?.disable();
    this.addEditCatalogForm.get('shipToAddrPopUp')?.valueChanges.subscribe(value => {
      if (value == 3) {
        this.addEditCatalogForm.get('checkoutMsg')?.enable();
      }
      else {
        this.addEditCatalogForm.get('checkoutMsg')?.disable();
      }
    });
    this.addEditCatalogForm.get('copyCatId')?.valueChanges.subscribe(value => {
      if(value){
      this.apiService.getCatalogDetail(value).subscribe(res => {
        this.loadCatalogValues(res);
      })
    }
    })
  }

  loadCatalogValues(data: any) {
    this.addEditCatalogForm.patchValue({
      checkCloseOut: data.checkCloseOut == 0 ? false : true,
      minimumInventory: data.minimumInventory,
      emailAddress: data.emailAddress,
      allowCloseOut: data.allowCloseOut == 0 ? false : true,
      allowKeywordSearch: data.allowKeywordSearch == 0 ? false : true,
      enableChat: data.enableChat == 0 ? false : true,
      enableBoldEmail: data.enableBoldEmail == 0 ? false : true,
      multiLotUpdate: data.multiLotUpdate == 0 ? false : true,
      checkoutMsg: data.checkoutMsg,
      notifyOptionalCustomize: data.notifyOptionalCustomize == 0 ? false : true,
      allowAddLettering: data.allowAddLettering == 0 ? false : true,
      notifyRemainingAllowance: data.notifyRemainingAllowance == 0 ? false : true,
      shipToAddrPopUp: data.shipToAddrPopUp.toString()
    });

  }

  initAddForm() {

    this.addEditCatalogForm = this.fb.group({
      catalogDesc: ['', [Validators.required, Validators.maxLength(100)]],
      checkCloseOut: [false],
      minimumInventory: [Validators.maxLength(7)],
      emailAddress: ['', Validators.maxLength(250)],
      allowCloseOut: [false],
      allowKeywordSearch: [false],
      enableStyleRef: [false],
      shipToAddrPopUp: ["0"],
      checkoutMsg: ['', Validators.maxLength(250)],
      notifyOptionalCustomize: [false],
      allowAddLettering: [false],
      copyCatId: [null],
      multiLotUpdate: [false]
    });
 this.addEditCatalogForm.get('emailAddress')?.disable({ emitEvent: false });
  this.addEditCatalogForm.get('minimumInventory')?.disable({ emitEvent: false });

    this.addEditCatalogForm.get('checkCloseOut')?.valueChanges.subscribe(val => {
      if (val) {
        this.addEditCatalogForm.get('emailAddress')?.enable({ emitEvent: false });
        this.addEditCatalogForm.get('minimumInventory')?.enable({ emitEvent: false });

      } else {
        this.addEditCatalogForm.get('emailAddress')?.disable({ emitEvent: false });
        this.addEditCatalogForm.get('emailAddress')?.setValue('');
        this.addEditCatalogForm.get('minimumInventory')?.disable({ emitEvent: false });
         this.addEditCatalogForm.get('minimumInventory')?.setValue('');

      }

      this.addEditCatalogForm.get('emailAddress')?.updateValueAndValidity();
      this.addEditCatalogForm.get('minimumInventory')?.updateValueAndValidity();
    });
  }
  saveCatalog() {
    if (!this.authService.webAdm)
      return;

    if (!this.addEditCatalogForm.get('catalogDesc')?.value) {
      this.invalidForm = true;
      this.catDesc.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return
    }
    this.invalidForm = false;
    let post = {
      "catalogDesc": this.addEditCatalogForm.value.catalogDesc,
      "checkCloseOut": this.addEditCatalogForm.value.checkCloseOut ? 1 : 0,
      "minimumInventory": this.addEditCatalogForm.value.minimumInventory,
      "emailAddress": this.addEditCatalogForm.value.emailAddress,
      "allowCloseOut": this.addEditCatalogForm.value.allowCloseOut ? 1 : 0,
      "allowKeywordSearch": this.addEditCatalogForm.value.allowKeywordSearch ? 1 : 0,
      "enableStyleRef": this.addEditCatalogForm.value.enableStyleRef ? 1 : 0,
      "shipToAddrPopUp": Number(this.addEditCatalogForm.value.shipToAddrPopUp),
      "checkoutMsg": this.addEditCatalogForm.value.checkoutMsg,
      "notifyOptionalCustomize": this.addEditCatalogForm.value.notifyOptionalCustomize ? 1 : 0,
      "allowAddLettering": this.addEditCatalogForm.value.allowAddLettering ? 1 : 0,
      "copyCatId": this.addEditCatalogForm.value.copyCatId,
      "multiLotUpdate":this.addEditCatalogForm.value.multiLotUpdate ? 1 : 0
    }
    this.loading = true;
    this.apiService.addCatalogData(post).subscribe(res => {
      this.apiService.createNotification('success', res.message);
      this.loading = false;
      this.catalogSaveEvt.emit('true');
    }, err => {
      this.apiService.createNotification('error', err?.error.message);
      this.loading = false;
    });
  }

  validateCatalogName() {
    if (this.catalogData && this.catalogData.length > 0 && this.addEditCatalogForm.get('catalogDesc')?.value) {
      return this.catalogData.some((node: any) => (this.addEditCatalogForm.get('catalogDesc')?.value).toUpperCase() === node.catalogName);
    }
  }

  resetForm(){
    this.addEditCatalogForm.reset();
    this.addEditCatalogForm.get('shipToAddrPopUp')?.setValue("0")
    this.showModal =false;

  }

  trimCatalogDesc() {
  const control = this.addEditCatalogForm.get('catalogDesc');
  if (control && control.value) {
    // .trim() removes spaces from both the beginning and end of the string
    const trimmedValue = control.value.trim();
    
    // updateValueAndValidity ensures validators rerun after trimming
    control.setValue(trimmedValue);
    control.updateValueAndValidity();
  }
}

}
